export default __webpack_public_path__ + "static/media/IconCalendar.9244c04f.svg";